module.exports = __webpack_public_path__ + "img/cultura_mobile_ingles.1e5706c4.png";